import Vue from 'vue';
import Vuex from 'vuex';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/Auth';
import AuctionModule from '@/store/Auction';
import SnackModule from '@/store/Snack';
import RouterModule from '@/store/Router';
import GroupModule from '@/store/Group';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    AuthModule,
    AuctionModule,
    SnackModule,
    RouterModule,
    GroupModule,
  },
});

export const authModule = getModule(AuthModule, store);
export const auctionModule = getModule(AuctionModule, store);
export const snackModule = getModule(SnackModule, store);
export const routerModule = getModule(RouterModule, store);
export const groupModule = getModule(GroupModule, store);

authModule.addLoginHook(groupModule.init);

export default store;
